import { Injectable } from '@angular/core';
import { BaseAccessService } from '@zaoblako/web/core/models/enums/access-rules/base-access.service';
import { BrsAccessRulesKeyEnum } from './brs-access-rules-key.enum';
import { BrsAccessRulesConst } from './brs-access-rules.const';

@Injectable({
  providedIn: 'root'
})
export class BrsAccessService extends BaseAccessService<BrsAccessRulesKeyEnum> {
  public constructor() {
    super(BrsAccessRulesConst);
  }

  // --- Платежи ---
  public get brsTaskRights() {
    return {
      canReadBrsTask: this.globalService.isAccessRule(BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_TASK_READ]),
      canWriteBrsTask: this.globalService.isAccessRule(BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_TASK_WRITE]),

      canReadDDS: this.globalService.isAccessRule(BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_DDS_READ]),

      canReadPaymentCalendar: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_PAYMENT_CALENDAR_READ]
      ),
      canWritePaymentCalendar: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_PAYMENT_CALENDAR_WRITE]
      ),

      canReadTemplate: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_TEMPLATE_READ]
      ),
      canWriteTemplate: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_TEMPLATE_WRITE]
      ),

      canReadStatus: this.globalService.isAccessRule(BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_STATUS_READ]),
      canWriteStatus: this.globalService.isAccessRule(BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_STATUS_WRITE]),

      canReadSettings: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_SETTINGS_READ]
      ),
      canWriteSettings: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_SETTINGS_WRITE]
      ),

      canReadPaymentScenario: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_PAYMENT_SCENARION_READ]
      ),
      canWritePaymentScenario: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_PAYMENT_SCENARION_WRITE]
      ),
      canMakePaidUnderpaymentTasks: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_MAKE_PAID_UNDERPAYMENT_TASKS]
      )
    };
  }

  public get brsTaskPermissions() {
    return {
      canAccessToAllSavedFilters: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_ACCESS_TO_ALL_SAVED_FILTERS]
      ),
      canReadAllTasks: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_READ_ALL_TASKS]
      ),
      canEditOtherUsersTasks: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_EDIT_OTHER_USERS_TASKS]
      ),
      canApproveInsteadOfOthers: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_APPROVE_INSTEAD_OF_OTHERS]
      ),
      canDeleteOtherUserTaskComments: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_DELETE_OTHER_USER_TASK_COMMENTS]
      ),
      canRefuseAgreedAndSentTasks: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_REFUSE_AGGREED_AND_SENT_TASKS]
      ),
      canReadAllPlannedIncomes: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_READ_ALL_PLANNED_INCOMES]
      ),
      canEditOtherUsersPlannedIncomes: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_EDIT_OTHER_USERS_PLANNED_INCOMES]
      ),
      canDeleteOtherUserPlannedIncomeComments: this.globalService.isAccessRule(
        BrsAccessRulesConst[BrsAccessRulesKeyEnum.BRS_BRS_DELETE_OTHER_USER_PLANNED_INCOME_COMMENTS]
      )
    };
  }
}
